import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Button, CloseButton, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { t } from 'i18next';
import EditPopup from './EditPopup';
import ImageViewPopup from './ImageViewPopup';
import EventViewPopup from './EventViewPopup';
import TextViewPopup from './TextViewPopup';
import { imgPath, planDialog } from '../service/CommonUtil';
import TextEditPopup from './TextEditPopup';
import EventEditPopup from './EventEditPopup';
import VideoViewPopup from './VideoViewPopup';
import VideoEditPopup from './VideoEditPopup';
import MuiButton from "@mui/material/Button";
import PostLimit from './upload/PostLimit';
import CharacterEditPopup from './CharacterEditPopup';
import { Alert, Box, CircularProgress, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import MuiDialog from '@mui/material/Dialog';
import { ModelCard } from './generate/ModelSelector';
import { Close, Delete as DeleteIcon } from '@mui/icons-material';
import TrackCard from './music/TrackCard';

const Manage = () => {
    async function getList(type,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/my/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(type,groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/post/"+groupId).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    // モデル削除API呼び出し
    async function deleteModel(modelId) {
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/model/deleteModel/"+modelId)
            .then(r => r.json().then(d => d));
    }
    // 音楽取得API
    async function getMusicList(contentType, page) {
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/music/my/"+contentType+"/"+page)
            .then(r => r.json().then(json => json));
    }
    // 音楽削除API
    async function deleteMusic(contentType, id) {
        const endpoint = contentType === 'tracks' ? 'track' : 'album';
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/music/"+endpoint+"/"+id)
            .then(r => r.json().then(d => d));
    }
    // 音楽再生/停止
    const handlePlayAudio = (audioUrl, trackId) => {
        if (playingTrackId === trackId && currentAudio) {
            // 同じトラックをクリック → 停止
            currentAudio.pause();
            setCurrentAudio(null);
            setPlayingTrackId(null);
        } else {
            // 別のトラックまたは新規再生
            if (currentAudio) {
                currentAudio.pause();
            }
            const audio = new Audio(audioUrl);
            audio.play();
            audio.addEventListener('ended', () => {
                setPlayingTrackId(null);
                setCurrentAudio(null);
            });
            setCurrentAudio(audio);
            setPlayingTrackId(trackId);
        }
    };
    
    // 音楽いいね機能
    const [musicFavoriteLoading, setMusicFavoriteLoading] = useState({});
    
    const toggleMusicFavoriteApi = async (trackId, isFavorite) => {
        try {
            const method = isFavorite ? 'delete' : 'post';
            const response = await new ApiFetch()[method](
                `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/favorite/music_track/${trackId}`,
                method === 'post' ? {} : undefined
            );
            return await response.json();
        } catch (error) {
            console.error('Error toggling music favorite:', error);
            return { result: false };
        }
    };

    const handleToggleMusicFavorite = async (trackId) => {
        setMusicFavoriteLoading(prev => ({ ...prev, [trackId]: true }));
        const targetTrack = musicList.tracks.find(track => track.track_id === trackId);
        if (!targetTrack) {
            setMusicFavoriteLoading(prev => ({ ...prev, [trackId]: false }));
            return;
        }

        const isFavorite = targetTrack.is_favorited === 1;
        const response = await toggleMusicFavoriteApi(trackId, isFavorite);

        if (response.result) {
            setMusicList(prev => ({
                ...prev,
                tracks: prev.tracks.map(track => {
                    if (track.track_id === trackId) {
                        return { 
                            ...track, 
                            is_favorited: track.is_favorited === 1 ? 0 : 1,
                            favorite_count: track.is_favorited === 1 ? (track.favorite_count - 1) : (track.favorite_count + 1)
                        };
                    }
                    return track;
                })
            }));
        } else {
            console.error('Music favorite toggle failed:', response);
        }

        setMusicFavoriteLoading(prev => ({ ...prev, [trackId]: false }));
    };
    
    // 削除ボタン押下時
    const handleDeleteButton = (model) => {
        setDeleteTargetModel(model);
        setDeleteDialogOpen(true);
    };

    // 削除確定時
    const handleDeleteConfirm = async () => {
        if(type === "model" && deleteTargetModel) {
            setIsLoading(true);
            const res = await deleteModel(deleteTargetModel.model_id);
            setIsLoading(false);
            setDeleteDialogOpen(false);
            setDeleteTargetModel(null);
            if(res.result){
                setDeleted(deleteTargetModel.model_id);
            } else {
                dialog("エラー", res.errors ? res.errors.join("\n") : "削除に失敗しました");
            }
        } else {
            setDeleteDialogOpen(false);
            setDeleteTargetModel(null);
        }
    };
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate()
    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // URLパラメータ
    let param = useParams();

    const [type,setType] = useState('image')
    const [imageList,setImageList] = useState([...Array(0)])
    const [message,setMessage] = useState('')
    const [item, selectItem] = useState('')
    const [deleted, setDeleted] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [musicType, setMusicType] = useState('tracks') // tracks or albums
    const [musicList, setMusicList] = useState({ tracks: [], albums: [] })
    const [currentAudio, setCurrentAudio] = useState(null) // 現在再生中のAudio要素
    const [playingTrackId, setPlayingTrackId] = useState(null) // 再生中のトラックID

    // 検索情報
    const [page,setPage] = useState(0)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 削除ダイアログ用 state
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteTargetModel, setDeleteTargetModel] = useState(null);

    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    // 初期処理とページ遷移
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = t("manage.title") + " - アワートAI"

        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0){
            if(loginInfo.result){ // ログイン確認が終わるまで待機する必要あり。
                setIsLoading(true)
                if(type === 'music'){
                    getMusicList(musicType, currentPage).then(json => {
                        if(json.result){
                            const data = musicType === 'tracks' ? json.tracks : json.albums;
                            if(data && data.length > 0){
                                setMessage("")
                                setMusicList(prev => ({ ...prev, [musicType]: data }))
                            } else {
                                setMessage("まだ投稿がありません。あなたも投稿してみませんか？")
                                setMusicList(prev => ({ ...prev, [musicType]: [] }))
                            }
                        }
                        setIsLoading(false)
                    })
                } else {
                    getList(type,currentPage).then(json => {
                        if(json.result){
                            if(json.data.length > 0){
                                setMessage("")
                            } else {
                                setMessage("まだ投稿がありません。あなたも投稿してみませんか？")
                            }
                            // スクロールを最上位に戻す
                            window.scrollTo({top:0,left:0,behavior:"instant"})
                            setImageList(json.data)
                        }
                        setIsLoading(false)
                    })
                }
            }
        }
    },[loginInfo,deleted,page,type,musicType])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            deleteImage(type,item).then(r=>{
                if(r.result){
                    setDeleted(item)
                } else {
                    dialog("エラー",r.errors)
                }
                setOkButtonShow(false)
            })
        }}>OK</Button>
    }
    const [showEditPopup,setShowEditPopup] = useState(false)
    const [groupId,setGroupId] = useState("")
    const [showImageViewPopup,setShowImageViewPopup] = useState(false)
    const [showVideoViewPopup,setShowVideoViewPopup] = useState(false)
    const [showTextViewPopup,setShowTextViewPopup] = useState(false)
    const [showEventViewPopup,setShowEventViewPopup] = useState(false)
    const [index,setIndex] = useState(0)
    function imageUrl(data,type){
        if(type === "video"){
            if(data.status >= 4){
                return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
            } else {
                return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/encode.webp'
            }
        } else {
            return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
        }
    }
    // Define breakpoints for grid columns
    const gridBreakpoints = {
        xs: 2, // Extra small devices (phones)
        sm: 3, // Small devices (tablets)
        md: 4, // Medium devices (small laptops)
        lg: 5, // Large devices (desktops)
        xl: 6, // Extra large devices (large desktops)
    };
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        {/* 削除確認ダイアログ */}
        <MuiDialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
            <DialogContent>
                <Typography>本当に「{deleteTargetModel?.name}」を削除しますか？</Typography>
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={() => setDeleteDialogOpen(false)}>キャンセル</MuiButton>
                <MuiButton color="error" onClick={handleDeleteConfirm}>削除</MuiButton>
            </DialogActions>
        </MuiDialog>
        {showEditPopup && type === "character" ? <CharacterEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "image" ? <EditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "video" ? <VideoEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "text" ? <TextEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "event" ? <EventEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showImageViewPopup ? <ImageViewPopup groupId={groupId} switch={setShowImageViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showVideoViewPopup ? <VideoViewPopup groupId={groupId} switch={setShowVideoViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showTextViewPopup ? <TextViewPopup groupId={groupId} switch={setShowTextViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showEventViewPopup ? <EventViewPopup groupId={groupId} switch={setShowEventViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>{t("manage.title")}</Container>
        <Container>
            <MuiButton variant={type === "character" ? "contained" : "outlined"} onClick={() => setType("character")} className='m-1'>キャラクター</MuiButton>
            <MuiButton variant={type === "image" ? "contained" : "outlined"} onClick={() => setType("image")} className='m-1'>{t("upload.image.title")}</MuiButton>
            <MuiButton variant={type === "video" ? "contained" : "outlined"} onClick={() => setType("video")} className='m-1'>{t("upload.video.title")}</MuiButton>
            <MuiButton variant={type === "text" ? "contained" : "outlined"} onClick={() => setType("text")} className='m-1'>{t("upload.text.title")}</MuiButton>
            <MuiButton variant={type === "event" ? "contained" : "outlined"} onClick={() => setType("event")} className='m-1'>{t("upload.event.title")}</MuiButton>
            <MuiButton variant={type === "music" ? "contained" : "outlined"} onClick={() => setType("music")} className='m-1'>音楽</MuiButton>
            <MuiButton variant={type === "model" ? "contained" : "outlined"} onClick={() => setType("model")} className='m-1'>{t("common.model")}</MuiButton>
        </Container>
        {type === "image" ? <PostLimit /> : ""}
        <Container>
            {type === "image" && imageList.find(data => (data.problem_status === 1 || data.problem_status === 2) && data.problem_reason !== 3) !== undefined ? <>
                <Alert severity='warning' color='warning'>
                    対応が必要な投稿があります。削除または修正され、審査が完了するまで非公開状態になります。また、対応が完了するまで新規の投稿はできません。
                    <ul>
                    {imageList.filter(d => d.problem_status !== 0).map(d => {
                        return <li style={{cursor:"pointer"}} onClick={() => {
                            setShowEditPopup(true)
                            setGroupId(d.group_id)
                        }}>{d.title}</li>
                    })}
                    </ul>
                </Alert>
            </> : ""}
        </Container>
        {type === "model" ? (
            <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                    <CircularProgress />
                    </Box>
                ) : imageList.length === 0 ? (
                    <Box sx={{ textAlign: 'center', p: 4 }}>
                    <Typography variant="body1">該当するモデルが見つかりません</Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2}>
                    {imageList.map(model => (
                        <Grid item
                        key={model.id}
                        xs={12 / gridBreakpoints.xs}
                        sm={12 / gridBreakpoints.sm}
                        md={12 / gridBreakpoints.md}
                        lg={12 / gridBreakpoints.lg}
                        xl={12 / gridBreakpoints.xl}
                        >
                        <ModelCard
                            model={model}
                            isSelected={false}
                            onSelect={() => {
                                navigate('/model/' + model.model_id);
                            }}
                            onEditButton={() => navigate(`/upload/model/${model.model_id}`)}
                            onDeleteButton={() => handleDeleteButton(model)}
                        />
                        </Grid>
                    ))}
                    </Grid>
                )}
            </Box>
        ) : type === "music" ? (
            <Box sx={{ p: 2 }}>
                <Container className='mb-3'>
                    <MuiButton 
                        variant={musicType === 'tracks' ? 'contained' : 'outlined'} 
                        onClick={() => setMusicType('tracks')}
                        className='m-1'
                    >
                        トラック
                    </MuiButton>
                    <MuiButton 
                        variant={musicType === 'albums' ? 'contained' : 'outlined'} 
                        onClick={() => setMusicType('albums')}
                        className='m-1'
                    >
                        アルバム
                    </MuiButton>
                </Container>
                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Grid container spacing={0.5} sx={{ p: 2 }}>
                        {musicType === 'tracks' ? (
                            // トラック表示: TrackCardコンポーネントを使用
                            musicList.tracks.map((track, i) => (
                                <Grid item
                                    key={i}
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={2.4}
                                    xl={2}
                                >
                                    <TrackCard
                                        track={track}
                                        isPlaying={playingTrackId === track.track_id}
                                        onPlay={() => handlePlayAudio(track.audio_file_url, track.track_id)}
                                        onToggleFavorite={() => handleToggleMusicFavorite(track.track_id)}
                                        isFavoriteLoading={musicFavoriteLoading?.[track.track_id]}
                                        onDelete={() => {
                                            if(window.confirm(`「${track.title}」を削除しますか？`)){
                                                deleteMusic('tracks', track.track_id)
                                                    .then(res => {
                                                        if(res.result){
                                                            setDeleted(track.track_id);
                                                        } else {
                                                            alert(res.error || '削除に失敗しました');
                                                        }
                                                    });
                                            }
                                        }}
                                        showDelete={true}
                                        size="sm"
                                    />
                                </Grid>
                            ))
                        ) : (
                            // アルバム表示: 既存のコード
                            musicList.albums.map((item, i) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={i}>
                                <Box sx={{ 
                                    border: '1px solid', 
                                    borderColor: playingTrackId === item.track_id ? 'primary.main' : 'divider',
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    bgcolor: 'background.paper',
                                    transition: 'all 0.2s',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: musicType === 'tracks' ? { xs: 'row', sm: 'column' } : 'column',
                                    '&:hover': { 
                                        boxShadow: 3,
                                        transform: 'translateY(-2px)'
                                    }
                                }}>
                                    {/* カバーアート */}
                                    <Box sx={{ 
                                        position: 'relative',
                                        width: musicType === 'tracks' ? { xs: 80, sm: '100%' } : '100%',
                                        paddingTop: musicType === 'tracks' ? { xs: 0, sm: '100%' } : '100%',
                                        height: musicType === 'tracks' ? { xs: 80, sm: 'auto' } : 'auto',
                                        bgcolor: 'grey.200',
                                        overflow: 'hidden',
                                        flexShrink: 0
                                    }}>
                                        {(item.cover_art_url_small || item.cover_art_url) ? (
                                            <picture style={{ 
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%', 
                                                height: '100%'
                                            }}>
                                                {/* WebP画像をレスポンシブに使用 */}
                                                {item.cover_art_url_large && (
                                                    <source 
                                                        media="(min-width: 768px)" 
                                                        srcSet={item.cover_art_url_medium} 
                                                        type="image/webp" 
                                                    />
                                                )}
                                                {item.cover_art_url_small && (
                                                    <source 
                                                        srcSet={item.cover_art_url_small} 
                                                        type="image/webp" 
                                                    />
                                                )}
                                                {/* フォールバック: 元画像 */}
                                                <img 
                                                    src={item.cover_art_url} 
                                                    alt={item.title} 
                                                    style={{ 
                                                        width: '100%', 
                                                        height: '100%', 
                                                        objectFit: 'cover' 
                                                    }} 
                                                />
                                            </picture>
                                        ) : (
                                            <Box sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Icon.MusicNoteBeamed size={48} color="#999" />
                                            </Box>
                                        )}
                                        {/* 再生ボタンオーバーレイ（トラックのみ） */}
                                        {musicType === 'tracks' && item.audio_file_url && (
                                            <Box sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                display: { xs: 'flex', sm: 'flex' },
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                bgcolor: 'rgba(0,0,0,0.3)',
                                                opacity: { xs: 1, sm: playingTrackId === item.track_id ? 1 : 0 },
                                                transition: 'opacity 0.2s',
                                                '&:hover': { opacity: 1 }
                                            }}>
                                                <MuiButton
                                                    variant="contained"
                                                    onClick={() => handlePlayAudio(item.audio_file_url, item.track_id)}
                                                    sx={{ 
                                                        minWidth: 'auto', 
                                                        width: { xs: 40, sm: 56 },
                                                        height: { xs: 40, sm: 56 },
                                                        p: 0,
                                                        borderRadius: '50%',
                                                        bgcolor: 'primary.main',
                                                        '&:hover': { bgcolor: 'primary.dark' }
                                                    }}
                                                >
                                                    {playingTrackId === item.track_id ? (
                                                        <Icon.PauseFill size={{ xs: 18, sm: 24 }} />
                                                    ) : (
                                                        <Icon.PlayFill size={{ xs: 18, sm: 24 }} />
                                                    )}
                                                </MuiButton>
                                            </Box>
                                        )}
                                    </Box>
                                    
                                    {/* 情報エリア */}
                                    <Box sx={{ 
                                        p: 1.5, 
                                        flex: 1, 
                                        display: 'flex', 
                                        flexDirection: 'column',
                                        minWidth: 0
                                    }}>
                                        <Typography 
                                            variant="subtitle2" 
                                            sx={{ 
                                                fontWeight: 600, 
                                                mb: 0.5,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: musicType === 'tracks' ? { xs: 'block', sm: '-webkit-box' } : '-webkit-box',
                                                WebkitLineClamp: musicType === 'tracks' ? { xs: 1, sm: 2 } : 2,
                                                WebkitBoxOrient: 'vertical',
                                                minHeight: musicType === 'tracks' ? { xs: 'auto', sm: '2.5em' } : '2.5em'
                                            }}
                                        >
                                            {item.title}
                                        </Typography>
                                        {musicType === 'tracks' && item.album_title && (
                                            <Typography variant="caption" color="text.secondary" noWrap sx={{ mb: { xs: 0.25, sm: 0.5 } }}>
                                                <Icon.CollectionPlay size={12} style={{ marginRight: 2, verticalAlign: 'text-bottom' }} />
                                                {item.album_title}
                                            </Typography>
                                        )}
                                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                <Icon.PlayCircle size={12} />
                                                {item.view_count || 0}
                                            </Typography>
                                            {musicType === 'tracks' ? (
                                                <>
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                        <Icon.HeartFill size={12} />
                                                        {item.favorite_count || 0}
                                                    </Typography>
                                                    {item.duration && (
                                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                            <Icon.Clock size={12} />
                                                            {Math.floor(item.duration / 60)}:{String(item.duration % 60).padStart(2, '0')}
                                                        </Typography>
                                                    )}
                                                </>
                                            ) : (
                                                <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                                                    <Icon.MusicNoteList size={12} />
                                                    {item.track_count || 0}曲
                                                </Typography>
                                            )}
                                        </Box>
                                        
                                        {/* トラックリスト（アルバムのみ） */}
                                        {musicType === 'albums' && item.tracks && item.tracks.length > 0 && (
                                            <Box sx={{ 
                                                mt: 1.5,
                                                mb: 1.5,
                                                maxHeight: 200,
                                                overflowY: 'auto',
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                borderRadius: 1,
                                                '&::-webkit-scrollbar': {
                                                    width: '6px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    bgcolor: 'grey.100',
                                                    borderRadius: 1
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    bgcolor: 'grey.400',
                                                    borderRadius: 1,
                                                    '&:hover': {
                                                        bgcolor: 'grey.500'
                                                    }
                                                }
                                            }}>
                                                {item.tracks.map((track, j) => (
                                                    <Box key={j} sx={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        gap: 1,
                                                        p: 1,
                                                        bgcolor: playingTrackId === track.track_id ? 'action.selected' : 'transparent',
                                                        transition: 'background-color 0.2s',
                                                        '&:hover': { 
                                                            bgcolor: 'action.hover'
                                                        },
                                                        borderBottom: j < item.tracks.length - 1 ? '1px solid' : 'none',
                                                        borderColor: 'divider'
                                                    }}>
                                                        {/* トラック番号 */}
                                                        <Typography 
                                                            variant="caption" 
                                                            color={playingTrackId === track.track_id ? 'primary' : 'text.secondary'}
                                                            sx={{ minWidth: 20, textAlign: 'center', fontWeight: 600, fontSize: '0.7rem' }}
                                                        >
                                                            {track.track_number}
                                                        </Typography>
                                                        
                                                        {/* 再生ボタン */}
                                                        {track.audio_file_url && (
                                                            <MuiButton
                                                                variant={playingTrackId === track.track_id ? "contained" : "text"}
                                                                size="small"
                                                                onClick={() => handlePlayAudio(track.audio_file_url, track.track_id)}
                                                                sx={{ 
                                                                    minWidth: 'auto', 
                                                                    width: 24,
                                                                    height: 24,
                                                                    p: 0,
                                                                    borderRadius: '50%'
                                                                }}
                                                            >
                                                                {playingTrackId === track.track_id ? <Icon.PauseFill size={12} /> : <Icon.PlayFill size={12} />}
                                                            </MuiButton>
                                                        )}
                                                        
                                                        {/* タイトル */}
                                                        <Typography 
                                                            variant="caption" 
                                                            noWrap 
                                                            sx={{ 
                                                                flex: 1, 
                                                                overflow: 'hidden', 
                                                                textOverflow: 'ellipsis',
                                                                fontWeight: playingTrackId === track.track_id ? 600 : 400,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        >
                                                            {track.title}
                                                        </Typography>
                                                        
                                                        {/* 再生時間 */}
                                                        <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, fontSize: '0.7rem' }}>
                                                            {Math.floor(track.duration / 60)}:{String(track.duration % 60).padStart(2, '0')}
                                                        </Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                        
                                        {/* 削除ボタン */}
                                        <MuiButton 
                                            size="small" 
                                            color="error"
                                            variant="outlined"
                                            fullWidth
                                            startIcon={<DeleteIcon />}
                                            onClick={() => {
                                                if(window.confirm(`「${item.title}」を削除しますか？`)){
                                                    deleteMusic(musicType, musicType === 'tracks' ? item.track_id : item.album_id)
                                                        .then(res => {
                                                            if(res.result){
                                                                setDeleted(item.track_id || item.album_id);
                                                            } else {
                                                                alert(res.error || '削除に失敗しました');
                                                            }
                                                        });
                                                }
                                            }}
                                            sx={{ mt: 'auto' }}
                                        >
                                            削除
                                        </MuiButton>
                                    </Box>
                                </Box>
                            </Grid>
                        ))
                        )}
                        {(musicType === 'tracks' ? musicList.tracks : musicList.albums).length === 0 && (
                            <Grid item xs={12}>
                                <Typography align="center" color="text.secondary" sx={{ py: 4 }}>
                                    {message}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                )}
            </Box>
        )
        :(<div className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {message}
            {imageList.map((data,i) => {
                if(i === 100){
                    return ""
                }
            return <Container style={{position:"relative",width:"180px"}} className="mb-3 p-0" key={i}>
                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 3 ? "block":"none"}}>
                                R-15
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 4 ? "block":"none"}}>
                                R-18
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 5 ? "block":"none"}}>
                                R-18G
                            </Badge>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:data.img_count > 1 ? "block":"none"}}>
                                <Icon.CollectionFill /> {data.img_count}
                            </Badge>
                            <CloseButton style={{position:"absolute",zIndex:"1",top:"20px",right:"20px",backgroundColor:"#FFFFFF"}} onClick={()=>{
                                selectItem(data.group_id)
                                setOkButtonShow(true)
                                dialog("確認",
                                    <Container style={{margin:"0 auto"}}>
                                        <Container className='text-center'>{t("common.delete")}</Container>
                                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                                            <Image src={imageUrl(data,type)} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",borderRadius:"20px"}} className="p-2" />
                                        </Container>
                                        <Container style={{fontWeight:"bold",fontSize:"15px"}} className='text-center'>{data.title}</Container>
                                    </Container>
                                    )
                            }} />
                            <Badge bg="white" style={{display:type === "video" && data.status === 4 ? "block" : "none",cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",left:"20px"}}
                                onClick={() => {
                                    dialog(t("common.info"),<div>動画を公開するには、必須情報の登録が必要です。<br />編集画面からタイトル等を設定してください。</div>)
                                }}>
                                <Icon.ExclamationCircle style={{color:"#FF0000",fontSize:"18px"}} />
                            </Badge>
                            <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}}
                                onClick={() => {
                                    setShowEditPopup(true)
                                    setGroupId(data.group_id)
                                }}>
                                <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>{t("common.edit")}</span>
                            </Badge>
                            <Badge bg="secondary" style={{cursor:"pointer",position:"absolute",padding:"3px",zIndex:1,bottom:"20px",right:"50px",display:data.limited_publication === 1 ? "block":"none"}}>
                                <Icon.EyeFill style={{color:"#FFFFFF",fontSize:"16px"}} />
                            </Badge>
                            <Badge bg="secondary" style={{cursor:"pointer",position:"absolute",padding:"3px",zIndex:1,bottom:"20px",left:"20px",display:data.booking_flg === 1 ? "block":"none"}}>
                                <RIcon.FaHistory title={t("common.booking")} style={{color:"#FFFFFF",fontSize:"16px"}} />
                            </Badge>
                            <FavoriteIcon type={type} id={data.group_id} style={{fontSize:"18px",cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} count={data.favorite_count} />
                            <Image
                            onClick={() => {
                                setGroupId(data.group_id)
                                setIndex(i)
                                if(type === 'character'){
                                    navigate("/character/"+data.group_id)
                                } else if(type === 'image'){
                                    setShowImageViewPopup(true)
                                } else if(type === 'video'){
                                    setShowVideoViewPopup(true)
                                } else if(type === 'text'){
                                    setShowTextViewPopup(true)
                                } else if(type === 'event'){
                                    setShowEventViewPopup(true)
                                }
                            }}
                            loading="lazy" src={imageUrl(data,type)}
                            style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="p-2" key={i} />
                        </Container>
                        <Container style={{fontWeight:"bold",fontSize:"15px"}}>
                            {type === "image" && data.problem_status === 1 ? <><Icon.ExclamationCircle style={{color:"red"}} />&nbsp;</> : ""}
                            {type === "image" && data.problem_status === 2 && data.problem_reason !== 3 ? <><Icon.InfoCircle style={{color:"red",cursor:"pointer"}} title="審査中" onClick={() => dialog("","再公開の審査中です。")}/>&nbsp;</> : ""}
                            <Link to={"/"+type+"/"+(data.group_id)} style={{color:"#555555",textDecoration:"none"}}>{type === 'character' ? <><ruby> {data.character_name} <rp>(</rp><rt>{data.character_name_kana}</rt><rp>)</rp> </ruby></> : data.title}</Link>
                        </Container>
                    </Container>
            })}
        </div>)}
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <MuiButton variant='outlined' onClick={() => {
                        let p = page - 1
                        setPage(p)
                        navigate("/manage/" + p)
                    } }>{t("common.prev")}</MuiButton>
                ) : <MuiButton variant='outlined' disabled>{t("common.prev")}</MuiButton>}
            {imageList.length > 100 ? (
                    <MuiButton variant='outlined' onClick={() => {
                        let p = page + 1
                        setPage(p)
                        navigate("/manage/" + p)
                    } }>{t("common.next")}</MuiButton>
                ) : <MuiButton variant='outlined' disabled>{t("common.next")}</MuiButton>}
        </Container>
        <Footer />
    </div>
    )
}

export default Manage;
